import { Component } from '@angular/core';

@Component({
    selector: 'app-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.css'],
    standalone: false
})
export class LogsComponent {

}
